module.exports = __webpack_public_path__ + "05_short_black.7aeaa255.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer5/05_short_black.png
// module id = aAuU
// module chunks = 0